// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__YQ_Ev","paramInput":"JobSimulator_paramInput__MDlIA","input":"JobSimulator_input__AD77b"};